export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11453.c5ec55b1.jpg";